(function () {
  /**
   * Core Swiper Initialization
   */
  const initProductSlider = (container) => {
    const parentId = `#${container.id}`;
    const selectors = {
      carousel: '.js-swiper-product-carousel',
      scrollbar: '.js-product-carousel-swiper-scrollbar',
      prev: '.js-product-carousel-arrow-prev',
      next: '.js-product-carousel-arrow-next',
      navTools: '.product-carousel_nav-tools'
    };

    const el = {
      carousel: container.querySelector(selectors.carousel),
      scrollbar: container.querySelector(selectors.scrollbar),
      prev: container.querySelector(selectors.prev),
      next: container.querySelector(selectors.next),
      navTools: container.querySelector(selectors.navTools)
    };

    if (!el.carousel) return;

    // Destroy existing instance to prevent memory leaks/glitches
    if (el.carousel.swiper) el.carousel.swiper.destroy(true, true);

    new Swiper(el.carousel, {
      slidesPerView: 2.2,
      spaceBetween: 1,
      grabCursor: false,
      watchSlidesProgress: true,
      touchReleaseOnEdges: true,
      observer: true,
      observeParents: true,

      freeMode: {
        enabled: true,
        momentumRatio: 1.2,
        momentumFriction: 0.01,
        momentumBounce: false
      },

      navigation: {
        prevEl: el.prev,
        nextEl: el.next,
      },

      scrollbar: {
        el: el.scrollbar,
        draggable: true,
        snapOnRelease: true,
      },

      breakpoints: {
        750: { slidesPerView: 2.5 },
        990: { slidesPerView: 3.5 },
        1200: { slidesPerView: 4.5 }
      },

      on: {
        init: (s) => {
          s.slides.forEach(slide => slide.style.cursor = 'pointer');
          // Hide nav if arrows are locked (not enough products)
          if (s.navigation?.nextEl?.classList.contains('swiper-button-lock')) {
            if (el.navTools) el.navTools.style.display = 'none';
          }
        }
      }
    });
  };

  /**
   * Global Bootloader
   */
  const boot = () => {
    document.querySelectorAll('.js-get-section').forEach(initProductSlider);
  };

  // Initial Load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify Theme Editor & Dynamic Load Listener
  document.addEventListener('shopify:section:load', (e) => {
    const target = document.getElementById(`section-${e.detail.sectionId}`);
    if (target) initProductSlider(target);
  });

  /**
   * Recommendation Mutation Observer
   */
  const recEl = document.querySelector('product-recommendations');
  if (recEl) {
    new MutationObserver(mutations => {
      for (const m of mutations) {
        if (m.addedNodes.length) {
          document.dispatchEvent(new CustomEvent('shopify:section:load', {
            detail: { sectionId: recEl.dataset.sectionId }
          }));
          break; // Fire once and stop
        }
      }
    }).observe(recEl, { childList: true });
  }
})();